module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "sky-swiper-item",
    on: {
      "click": _vm.openLightbox
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-95850ab0"}!./scripts/sky-swiper/sky-swiper-item.html
// module id = 383
// module chunks = 1